import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ToolbarButton.scss";

export const types = ["none", "left", "middle", "right"];

export const statusColors = ["recording", "unread", "enabled", "disabled"];

export const TransparentTopToolbarButton = forwardRef(({ className, children, icon, statusColor, ...rest }, ref) => {
  return (
    <button
      ref={ref}
      className={classNames(
        "tw-relative",
        "tw-z-0",
        "tw-btn",
        "tw-btn-md",
        "tw-btn-circle",
        "tw-border",
        "tw-border-solid",
        "tw-border-neutral",
        "tw-backdrop-blur-[5px]",
        "tw-bg-neutral/40",
        "hover:tw-bg-neutral/40", // NOTE: ホバー色はbeforeの透明色でつける
        "active:tw-bg-neutral/40", // NOTE: ホバー色はbeforeの透明色でつける
        "tw-text-neutral-content/70",
        // NOTE: beforeでオーバーレイ(ホーバー色をつける)
        "before:tw-content-['']",
        "before:tw-absolute",
        "before:tw-inset-0",
        "before:-tw-z-10",
        "before:tw-rounded-full",
        "before:tw-transition-colors",
        "before:tw-bg-neutral-content/0",
        "hover:before:tw-bg-neutral-content/20",
        "active:before:tw-bg-neutral-content/20",
        className
      )}
      {...rest}
    >
      {icon}
      {statusColor && <div className={classNames(styles.statusIndicator, styles["status-" + statusColor])} />}
      {children}
    </button>
  );
});

TransparentTopToolbarButton.displayName = "TransparentTopToolbarButton";

TransparentTopToolbarButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.node,
  statusColor: PropTypes.oneOf(statusColors)
};
